var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 2033"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8 14C4.6862 14 2 11.3138 2 8C2 4.6862 4.6862 2 8 2C11.3138 2 14 4.6862 14 8C14 11.3138 11.3138 14 8 14ZM7.4 9.8V11H8.6V9.8H7.4ZM8.6 8.813C9.0822 8.66767 9.49616 8.35397 9.76649 7.92905C10.0368 7.50412 10.1455 6.99623 10.0728 6.49788C10.0001 5.99953 9.75086 5.54386 9.37041 5.21387C8.98995 4.88388 8.50363 4.70152 8 4.7C7.51448 4.69985 7.04391 4.86794 6.66836 5.17566C6.29282 5.48338 6.0355 5.91173 5.9402 6.3878L7.1174 6.6236C7.15081 6.45646 7.23099 6.30224 7.34862 6.17889C7.46625 6.05554 7.61649 5.96813 7.78186 5.92682C7.94722 5.88552 8.12092 5.89203 8.28273 5.94558C8.44455 5.99914 8.58783 6.09754 8.6959 6.22935C8.80397 6.36115 8.8724 6.52093 8.89321 6.69011C8.91402 6.85928 8.88637 7.03088 8.81346 7.18495C8.74056 7.33902 8.6254 7.46922 8.4814 7.5604C8.33739 7.65158 8.17045 7.69999 8 7.7C7.84087 7.7 7.68826 7.76321 7.57574 7.87574C7.46321 7.98826 7.4 8.14087 7.4 8.3V9.2H8.6V8.813Z",
    fill: "white",
    fillOpacity: 0.6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.a57fe8ed98d3ee76ad562be56925b406.svg";
export { ForwardRef as ReactComponent };